import { TimestampsArr } from "./useTimestamps";

export const binSearch = (timestamps: TimestampsArr, timer: number) => {
	let left = 1;
	let right = timestamps.length - 1;
	while (left <= right) {
		const middle = Math.floor((left + right) / 2);
		if (timestamps[middle]?.end && (timestamps[middle].end ?? 0) < timer) {
			left = middle + 1;
		} else if (timestamps[middle]?.start && (timestamps[middle].start ?? 0) > timer) {
			right = middle - 1;
		} else {
			return middle;
		}
	}
	if (left < timestamps.length) {
		if (timestamps[left]?.start && (timestamps[left].start ?? 0) > timer) {
			return left;
		} else if (timestamps[right]?.start && (timestamps[right].start ?? 0) > timer) {
			return right;
		}
	}
	return timestamps.length - 1;
};
